module.exports = __webpack_public_path__ + "img/icon-come-funziona-raccontaci.eb13cc6e.svg";